document.addEventListener('DOMContentLoaded', () => {
  const sectionEl = document.querySelector('.colour-room-hero-section');
  if (!sectionEl) return;

  const layerEl = sectionEl.querySelector('.colour-room-icon-layer');
  const icons = [...sectionEl.querySelectorAll('.colour-room-icon')];

  if (!icons.length || !layerEl) return;

  icons.forEach((icon) => initDrag(icon));

  const getVisibleIcons = () => icons.filter((icon) => icon.offsetParent !== null);

  reposition(getVisibleIcons(), layerEl, sectionEl);

  let resizeTimer;
  new ResizeObserver(() => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => reposition(getVisibleIcons(), layerEl, sectionEl), 100);
  }).observe(layerEl);

function reposition(icons, layerEl, sectionEl) {
    icons.forEach((icon) => {
      if (icon._dragging) return;
      icon.style.left = icon.dataset.x;
      icon.style.top = icon.dataset.y;
      icon._bx = icon.offsetLeft;
      icon._by = icon.offsetTop;
    });

    avoidBanner(icons, layerEl, sectionEl);
    clampBounds(icons, layerEl);
    resolveOverlaps(icons, layerEl);
  }

function avoidBanner(icons, layerEl, sectionEl) {
    const banner = sectionEl.querySelector('.colour-room-banner');
    if (!banner) return;

    const bRect = banner.getBoundingClientRect();
    const lRect = layerEl.getBoundingClientRect();

    const pad = 10;
    const bL = bRect.left - lRect.left - pad;
    const bT = bRect.top - lRect.top - pad;
    const bR = bL + bRect.width + pad * 2;
    const bB = bT + bRect.height + pad * 2;

    icons.forEach((icon) => {
      const iL = icon._bx;
      const iT = icon._by;
      const iR = iL + icon.offsetWidth;
      const iB = iT + icon.offsetHeight;

      if (iR <= bL || iL >= bR || iB <= bT || iT >= bB) return;

      const dLeft = iR - bL;
      const dRight = bR - iL;
      const dTop = iB - bT;
      const dBottom = bB - iT;
      const minD = Math.min(dLeft, dRight, dTop, dBottom);

      if (minD === dLeft) icon._bx = bL - icon.offsetWidth;
      else if (minD === dRight) icon._bx = bR;
      else if (minD === dTop) icon._by = bT - icon.offsetHeight;
      else icon._by = bB;

      icon.style.left = icon._bx + 'px';
      icon.style.top = icon._by + 'px';
    });
  }

  function clampBounds(icons, layerEl) {
    const lW = layerEl.offsetWidth;
    const lH = layerEl.offsetHeight;

    icons.forEach((icon) => {
      const iW = icon.offsetWidth;
      const iH = icon.offsetHeight;

      if (icon._bx < 0) icon._bx = 0;
      else if (icon._bx + iW > lW) icon._bx = lW - iW;

      if (icon._by < 0) icon._by = 0;
      else if (icon._by + iH > lH) icon._by = lH - iH;

      icon.style.left = icon._bx + 'px';
      icon.style.top = icon._by + 'px';
    });
  }

  function resolveOverlaps(icons, layerEl) {
    const { offsetWidth: lW, offsetHeight: lH } = layerEl;

    for (let pass = 0; pass < 30; pass++) {
      let anyOverlap = false;

      for (let i = 0; i < icons.length; i++) {
        for (let j = i + 1; j < icons.length; j++) {
          const a = icons[i], b = icons[j];
          const dx = (b._bx + b.offsetWidth / 2) - (a._bx + a.offsetWidth / 2);
          const dy = (b._by + b.offsetHeight / 2) - (a._by + a.offsetHeight / 2);
          const dist = Math.sqrt(dx * dx + dy * dy) || 0.01;
          const push = (a.offsetWidth / 2 + b.offsetWidth / 2 - dist) / 2;

          if (push > 0) {
            anyOverlap = true;
            a._bx -= (dx / dist) * push;  a._by -= (dy / dist) * push;
            b._bx += (dx / dist) * push;  b._by += (dy / dist) * push;
          }
        }
      }

      icons.forEach((icon) => {
        icon._bx = Math.max(0, Math.min(icon._bx, lW - icon.offsetWidth));
        icon._by = Math.max(0, Math.min(icon._by, lH - icon.offsetHeight));
        icon.style.left = icon._bx + 'px';
        icon.style.top = icon._by + 'px';
      });

      if (!anyOverlap) break;
    }
  }

  function initDrag(el) {
    const startDrag = (clientX, clientY) => {
      el._dragging = true;
      el.classList.add('is-dragging');
      const startX = clientX;
      const startY = clientY;
      const startBx = el._bx;
      const startBy = el._by;

      return {
        onMove: (cx, cy) => {
          el._bx = startBx + (cx - startX);
          el._by = startBy + (cy - startY);
          el.style.left = el._bx + 'px';
          el.style.top = el._by + 'px';
        },
        onEnd: () => {
          el._dragging = false;
          el.classList.remove('is-dragging');
          el._fs = performance.now();
        }
      };
    };

    el.addEventListener('mousedown', (e) => {
      e.preventDefault();
      const { onMove, onEnd } = startDrag(e.clientX, e.clientY);
      const onMouseMove = (e) => onMove(e.clientX, e.clientY);
      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        onEnd();
      };
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    el.addEventListener('touchstart', (e) => {
      e.preventDefault();
      const t0 = e.touches[0];
      const { onMove, onEnd } = startDrag(t0.clientX, t0.clientY);
      const onTouchMove = (e) => {
        e.preventDefault();
        onMove(e.touches[0].clientX, e.touches[0].clientY);
      };
      const onTouchEnd = () => {
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
        onEnd();
      };
      document.addEventListener('touchmove', onTouchMove, { passive: false });
      document.addEventListener('touchend', onTouchEnd);
    }, { passive: false });
  }
});
